import { EMPTY_LIST } from '../../../../constants/common'
import { getIsRentalPortalApplicantIdentityMasked } from '../../../RentalPortalApplicant'
import { toViewingApplicantIdentity } from '../../../RentalPortalViewing'

export function getViewingProfileHeaderApplicant(viewingData) {
  return viewingData?.applicant
    ? toViewingApplicantIdentity(viewingData.applicant)
    : null
}

export function getIsViewingProfileApplicantMasked(applicant) {
  return applicant && getIsRentalPortalApplicantIdentityMasked(applicant)
}

export function getIsViewingProfileApplicantClickable({
  applicant,
  viewingData,
}) {
  return (
    viewingData?.applicant?.can_view &&
    !getIsViewingProfileApplicantMasked(applicant)
  )
}

export function getViewingProfileApplicants(viewingData) {
  return viewingData?.applicants ?? EMPTY_LIST
}

export function getHasViewingProfileApplicantList(applicants) {
  return applicants.length > 1
}
